module.exports = __webpack_public_path__ + "static/img/图形02.3b7fff1.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/图形02.png
// module id = VrI5
// module chunks = 24